<template>
  <RcDialog :model-value="true" title="Sign Out" :width="mobile ? '100%' : DialogUtils.SMALL" @closeDialog="handleClose" :fullscreen="mobile">
    <p class="my-8 text-center" style="font-size: 1.2em;">
      Are you sure you want to sign out?
    </p>

    <template #actions>
      <v-btn color="success" variant="flat" @click="handleSignOutConfirm">
        Sign Out
      </v-btn>
    </template>
  </RcDialog>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import RcDialog from '@/v3/components/library/dialog/RcDialog.vue';
import DialogUtils from '@/v3/utils/DialogUtils.js';
import Company from '@/domain/model/company/Company.js';

const emit = defineEmits(['closeDialog', 'signout']);

const store = useStore();
const { mobile } = useDisplay();

const domain = computed(() => store.getters.domain);
const auth_client = computed(() => store.getters.auth_client);

const handleSignOutConfirm = () => {
  store.commit('authClear');

  if (auth_client.value?.socket?.connection) {
    auth_client.value.socket.connection.close();
  }

  try {
    const value = window.localStorage["readyChek"];
    if (value) {
      const cookieData = JSON.parse(value);
      cookieData["auto"] = false;
      delete cookieData['Company'];
      window.localStorage.readyChek = JSON.stringify(cookieData);
    }
  } catch (e) {
    console.error("Failed to update local storage on sign out:", e);
  }

  domain.value?.cleanup();
  domain.value?.signOut();
  store.dispatch('AuthStorage_updateCompany', new Company(domain.value).withName("Administration Portal"));

  emit('signout');
};

const handleClose = () => {
  emit('closeDialog');
};
</script>
